import { addSeconds, differenceInMinutes, differenceInHours } from "date-fns";

import { WaitlistWaitWhileStatus } from "../../../Integrations/WaitWhile/Model/WaitlistWaitWhileStatus.csharp";
import { WaitlistCenterOpeningStatus } from "../../Blocks/Waitlist/WaitlistCenterOpeningStatus.csharp";
import { WaitWhileApi } from "../Api/WaitWhileApi";

const api = new WaitWhileApi();
const TIMEOUT = 10000;


export async function updateCenterOpeningStatus(
  contentId: number,
  setterFunction: (arg: WaitlistCenterOpeningStatus) => void
) {
  const result = await api.getRegistrationStatus(contentId);
  setterFunction(result);
  setTimeout(() => updateCenterOpeningStatus(contentId, setterFunction), TIMEOUT);
};

export async function updateWaitlistStatus(
  contentId: number,
  setterFunction: (arg: WaitlistWaitWhileStatus) => void
) {
  const result = await api.getWaitWhileStatus(contentId);
  setterFunction(result);
  setTimeout(() => updateWaitlistStatus(contentId, setterFunction), TIMEOUT);
};

export const getFormattedTime = (waitlistStatus: WaitlistWaitWhileStatus) => {
  if (waitlistStatus?.waitingTimeMessage) {
    return `<span class="fw-bold">${waitlistStatus.waitingTimeMessage}</span>${waitlistStatus.waitingTimeMessageAvailable ? " est. ventetid" : ""}`;
  }
}
